import { useEffect, useState, type FunctionComponent } from "react";
import { usePointsStore } from "@stores/points";
import { Input } from "@bracket/react-input";
import { Table } from "@bracket/react-table";
import { formattedPoints } from "@helpers";

export declare type LeaderBoardProps = {};

export const LeaderBoard: FunctionComponent<LeaderBoardProps> = ({}) => {
  const classes = () => [`leaderboard`].join(" ");

  const {
    leaderboard_rank,
    total_points,
    search_needle,
    onSearchUpdate,
    clearSearch,
    leaderboard,
    leaderboard_reduced,
  } = usePointsStore();

  useEffect(() => {
    return () => {
      clearSearch();
    };
  }, []);

  return (
    <div className={classes()}>
      <div className="tiles">
        <div className="tile">
          <div className="data">
            <div className="label">
              <p>Season 1 [BARS]</p>
            </div>
            <div className="value">
              <h3>{formattedPoints(total_points)}</h3>
            </div>
          </div>
        </div>

        <div className="tile">
          <div className="data">
            <div className="label">
              <p>Season 1 ranking</p>
            </div>
            <div className="value">
              <h3>{formattedPoints(leaderboard_rank + 1)}</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="search">
        <Input
          value={search_needle || ""}
          onChange={onSearchUpdate}
          width="20rem"
          placeholder="Search"
          icon="EyeGlass"
          iconProps={{
            style: { height: "1rem", fill: "white", paddingRight: "0.5rem" },
          }}
        />
      </div>
      <Table
        data={leaderboard_reduced || leaderboard || []}
        keys={["rank", "id", "total_points"]}
        formats={{
          total_points: (v) => {
            v = typeof v === "number" ? v : parseFloat(v);
            return Intl.NumberFormat("en-us").format(Math.round(v));
          },
          id: (v) => {
            v = typeof v === "string" ? v : v.toString();
            return v.slice(0, 4) + "..." + v.slice(v.length - 6, v.length);
          },
        }}
        titles={["Rank", "Account", "Total Points"]}
        rows={20}
      />
    </div>
  );
};
